<template>
    <cod-dialog
        ref="dialog"
        :show.sync="showDialog"
        :force-fullscreen="isAllegra"
        back-icon="fal fa-arrow-left"
    >
        <!-- Header -->
        <div slot="header" class="select-products-header">
            {{ $t('allegra.order.add_products') }}

            <v-btn
                text
                dark
                @click="selectProducts"
            >
                <v-icon class="mr-3">fal fa-check</v-icon> {{ $t('general.confirm') }}
            </v-btn>
        </div>

        <!-- Content -->
        <div slot="content" ref="content" class="select-products-content">
            <search-product
                v-show="!isAllegra"
                ref="searchProduct"
                height="52px"
                solo
                hide-details
                :preserve-selection="false"
                :products="products"
                @select="addProduct($event.product, $event.quantity)"
            />

            <v-virtual-scroll
                :bench="3"
                :items="selected"
                :height="vScrollHeight"
                item-height="50"
            >
                <template v-slot:default="{ item }">
                    <v-list-item :key="item.product.id" class="pa-0">
                        <v-list-item-action class="px-3 ma-0">
                            <v-checkbox
                                v-if="isAllegra"
                                :value="!!item.quantity"
                                @click="onRowClick(item)"
                            />
                        </v-list-item-action>

                        <v-list-item-content
                            :class="{ product: isAllegra }"
                            @click="onRowClick(item)"
                        >
                            <v-list-item-title>
                                {{ item.product.name }}
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action v-if="item.quantity" class="action">
                            <v-btn
                                icon
                                :disabled="item.quantity <= 0"
                                @click="setQuantity(item, item.quantity - 1)"
                            >
                                <v-icon>fal fa-minus</v-icon>
                            </v-btn>

                            <div class="quantity">{{ item.quantity }}</div>

                            <v-btn
                                icon
                                @click="setQuantity(item, item.quantity + 1)"
                            >
                                <v-icon>fal fa-plus</v-icon>
                            </v-btn>

                            <div class="price">
                                <div>{{ item.product.getPriceAfterTax().multiply(item.quantity).toFormat() }}</div>
                                <small class="price-pre-tax">
                                    ({{ $t('general.pre_tax') }} {{ item.product.getPriceBeforeTax().multiply(item.quantity).toFormat() }})
                                </small>
                            </div>
                        </v-list-item-action>
                    </v-list-item>

                    <v-divider />
                </template>
            </v-virtual-scroll>
        </div>
    </cod-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import CodDialog from '@/components/CodDialog';
import Product from '@/models/Product';
import SearchProduct from '@/views/shared/components/SearchProduct';

export default {
    name: 'SelectProducts',

    components: {
        CodDialog,
        SearchProduct
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
    },

    created() {
        this.vScrollHeight = !isAllegra ? 397 : (Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) - 58)

        this.products = Product.all().filter(product => product.is_sold)
    },

    data: () => ({
        showDialog: false,
        vScrollHeight: 600,
        selected: [],
        products: []
    }),

    watch: {
        show(val) {
            this.showDialog = val;

            setTimeout(() => {
                if(val && this.$refs.searchProduct) {
                    this.$refs.searchProduct.focus()
                }
            }, 200)

            this.selected = !isAllegra ? [] : this.products.map(product => {
                return {
                    quantity: 0,
                    product: product
                }
            })
        },

        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    computed: {
        ...mapGetters(['curOrder']),
    },

    methods: {
        selectProducts() {
            this.showDialog = false;

            const selected = this.selected.filter(item => !!item.quantity)

            if(!selected.length) {
                return
            }

            this.$emit('select', selected)
        },

        addProduct(product, quantity) {
            if(!quantity) {
                quantity = 1
            }

            const addedProduct = this.selected.find(item => item.product.id === product.id)
            if(addedProduct) {
                addedProduct.quantity += quantity;
            } else {
                this.selected.push({ product, quantity });
            }
        },

        onRowClick(item) {
            if(!isAllegra) return
            this.setQuantity(item, item.quantity ? null : 1)
        },

        setQuantity(item, quantity) {
            item.quantity = quantity;
            if(!isAllegra) {
                this.selected = this.selected.filter(item => !!item.quantity)
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.select-products-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.select-products-content {
    height: 450px;

    .product {
        cursor: pointer;
    }

    .action {
        flex-direction: row;
        align-items: center;
        margin: 0;

        .quantity {
            width: 30px;
            text-align: center;
            font-size: 16px;
        }

        .price {
            padding: 0 8px;
            width: 150px;
            font-size: 16px;
            text-align: right;

            .price-pre-tax {
                color: #676767;
            }
        }
    }
}
</style>
